import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import WebNavbar from "../../Container/Website/WebNavbar";
import LoginPage from "../../Components/LoginPage/LoginPage";
import AdminLogin from "../../Components/LoginPage/AdminLogin";
import EnquiryFormPage from "../../Container/Website/EnquiryFormPage";
import HomePage from "../../Container/Website/HomePage/HomePage";
import AboutUsPage from "../../Container/Website/AboutUsPage/AboutUsPage";
import Footer from "../../Container/Website/Footer";
import ServicesPage from "../../Container/Website/Services/ServicesPage";
import ContactPage from "../../Container/Website/ContactPage/ContactPage";
import BlogsPage from "../../Container/Website/BlogsPage/BlogsPage";
import MembershipPage from "../../Container/Website/MembershipPage";
import ReferalLogin from "../../Components/LoginPage/ReferalLogin";

const WebRoutes = () => {
  const { pathname } = useLocation();

  // 🔹 Scroll to top on route change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <>
      {/* Sticky Navbar */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1200,
          backgroundColor: "#fff",
        }}
      >
        <WebNavbar />
      </div>

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/membership" element={<MembershipPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/enquiry" element={<EnquiryFormPage />} />
        <Route path="/referal-login" element={<ReferalLogin />} />
      </Routes>

      <Footer />
    </>
  );
};

export default WebRoutes;
